import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import { ToastContainer } from 'react-toastify';

const FAD = () => {
  const reports = [
    { year: '2021-22', fileName: 'fad_2021_22.xlsx' },
    { year: '2022-23', fileName: 'fad_2022_23.xlsx' },
    { year: '2023-24', fileName: 'fad_2023_24.xlsx' },
  ];

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'Reports' },
          { link: '#', title: 'Depreciation Report' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color">
          <div className="col-3">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Depreciation Report
            </h4>
          </div>
        </div>
        <div className="card-body text-center">
          <h5 className="mb-4">Download Depreciation Reports</h5>
          {reports.map((report) => (
            <a
              key={report.year}
              target="_blank"
              rel="noopener noreferrer"
              href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=fad_reports/${report.fileName}`}
              style={{ backgroundColor: '#90c', color: 'white' }}
              className="btn btn-sm mx-2"
            >
              Download Report {report.year}
            </a>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default FAD;
